module.exports = __webpack_public_path__ + "img/exhibitionHall.ed7e49f5.png";